<template>
  <div class="dropdown-container">
    <SelectV02
      attach
      chips
      clearable
      dense
      deletable-chips
      item-text="key"
      multiple
      open-on-clear
      outlined
      placeholder="Pick options"
      return-object
      @focus="$emit('focus')"
      @input="$emit('input', $event)"
      :disabled="disabled"
      :displayLimit="displayLimit"
      :hide-no-data="hideNoData"
      :isRequired="isBrand"
      :isSearchable="true"
      :items="items"
      :label="label"
      :loading="loading"
      :menu-props="menuProps"
      :shouldSortValues="shouldSortValues"
      :showSelectAll="showSelectAll"
      :value="value"
    />
  </div>
</template>
<script>
import { SelectV02 } from '@mikmak/components';

export default {
  props: {
    value: Array,
    items: Array,
    label: String,
    disabled: Boolean,
    hideNoData: Boolean,
    isBrand: Boolean,
    loading: Boolean,
    shouldSortValues: Boolean,
    showSelectAll: Boolean,
    displayLimit: Number,
  },
  components: {
    SelectV02,
  },
  data() {
    return {
      menuProps: {
        allowOverflow: true,
        bottom: true,
        dense: true,
        offsetY: true,
        rounded: true,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.dropdown-container {
  width: 100%;
  height: 60px;
  ::v-deep #app {
    overflow: visible;
  }
  ::v-deep .vuetify-styling {
    overflow: visible;
    .selection-wrapper {
      padding-top: 12px;
    }
    .v-input--selection-controls .v-input__slot>.v-label {
      position: initial !important;
    }
  }
}
</style>
